import ObservableModel from "util/ObservableModel";
import EvaluationForm from "models/composer/Evaluation";
import User from "models/User";

const Calibration = ObservableModel.extend(
    {
        modelProperties: {
            evaluationForm: EvaluationForm,
            evaluators: User,
            expertEvaluator: User,
        },
        defaults: {
            evaluators: [],
        },
    },
    function () {}
);

export default Calibration;
